import { render, staticRenderFns } from "./TagAction.vue?vue&type=template&id=0cff8597&scoped=true&"
import script from "./TagAction.vue?vue&type=script&lang=js&"
export * from "./TagAction.vue?vue&type=script&lang=js&"
import style0 from "./TagAction.vue?vue&type=style&index=0&id=0cff8597&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff8597",
  null
  
)

export default component.exports